import { useState, useEffect } from 'react';
import { MainTitle } from 'components/MainTitle';
import { Nothing } from 'components/Nothing';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import styles from './Alerts.module.scss';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { Button } from 'ui/Button';
import { ReactComponent as IconPlus } from './img/iconPlus.svg';
import {
  useCanselAlertWorkSupportMutation,
  useGetAlertsWorkSupportQuery,
} from 'redux/Api/alertsWorkSupportApi/alertsWorkSupportApi';
import { AlertsWorkSupportList } from 'components/AlertsWorkSupportList';
import { Modal } from 'components/Modal';
import { CreateAlertsModal } from 'components/CreateAlertsModal';
import { Title } from 'components/Title';

export interface InitialDataType {
  id: number;
  title: string;
  text: string;
  start_at: string;
  end_at: string;
  created_at: string;
}

export const AlertsWorkSupport = () => {
  const [showModalCreateAlert, setShowModalCreateAlert] = useState(false);
  const [showModalCancelAlert, setShowModalCancelAlert] = useState(false);
  const [buttonCreateAlert, setButtonCreateAlert] = useState(false);
  const [initialData, setInitialData] = useState<InitialDataType | null>(null);
  const [cancelAlertId, setCancelAlertId] = useState<number | null>(null);

  const [canselAlertWorkSupport] = useCanselAlertWorkSupportMutation();

  const handleCancelAlert = () => {
    canselAlertWorkSupport({ id: String(cancelAlertId) });
    setShowModalCancelAlert(false);
  };

  const per_page = 50;

  const [queryParams, setQueryParams] = useState<any>({
    page: 1,
    per_page,
  });

  const { data } = useGetAlertsWorkSupportQuery(queryParams);
  const isLoading = false;

  // Накапливаем данные со всех загруженных страниц, чтобы новые страницы добавлялись к списку
  const [accumulatedAlerts, setAccumulatedAlerts] = useState<InitialDataType[]>([]);

  useEffect(() => {
    if (!data?.data || data?.meta?.current_page == null) return;
    const responsePage = data.meta.current_page;
    if (responsePage === 1) {
      setAccumulatedAlerts(data.data);
    } else {
      setAccumulatedAlerts((prev) => {
        const start = (responsePage - 1) * per_page;
        if (prev.length >= start + data.data.length) return prev;
        return [...prev.slice(0, start), ...data.data];
      });
    }
  }, [data, per_page]);

  const hasNextPage = data?.meta
    ? data?.meta?.last_page !== data?.meta?.current_page
    : false;

  const [intersectionRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore: () => setQueryParams((prev: any) => ({ ...prev, page: prev.page + 1 })),
    rootMargin: '0px 0px 800px 0px',
  });

  const handleCancel = () => {
    setShowModalCancelAlert(false);
  };

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <MainTitle title='Оповещения' count={data?.meta.total} />
        <Button
          onClick={() => {
            setShowModalCreateAlert(true);
            setButtonCreateAlert(true);
          }}
          theme='filed'>
          <div className={styles.textButton}>
            Создать
            <IconPlus style={{ width: '24px', height: '24px' }} />
          </div>
        </Button>
      </div>
      {isLoading ? (
        <LoadingSkeleton mt />
      ) : accumulatedAlerts.length ? (
        <AlertsWorkSupportList
          alertsList={accumulatedAlerts}
          intersectionRef={intersectionRef}
          setShowModalCancelAlert={setShowModalCancelAlert}
          setShowModalCreateAlert={setShowModalCreateAlert}
          setInitialData={setInitialData}
          setCancelAlertId={setCancelAlertId}
          setButtonCreateAlert={setButtonCreateAlert}
        />
      ) : (
        <Nothing style={{ height: '750px' }} title='Ничего не найдено' />
      )}
      {showModalCreateAlert && (
        <CreateAlertsModal
          initialData={initialData}
          setInitialData={setInitialData}
          setOpen={setShowModalCreateAlert}
          buttonCreateAlert={buttonCreateAlert}
          setButtonCreateAlert={setButtonCreateAlert}
        />
      )}
      {showModalCancelAlert && (
        <Modal setOpen={setShowModalCancelAlert}>
          <div className={styles.rootModal}>
            <Title className={styles.titleModal} title='Подтверждение отмену' />
            <span style={{ marginBottom: '10px', fontSize: '16px' }}>
              Вы уверены, что хотите отменить оповещение?
            </span>
            <div className={styles.containerBtn}>
              <div>
                <Button
                  theme='outline'
                  className={styles.button_cancel}
                  onClick={() => {
                    handleCancel();
                    setCancelAlertId(null);
                  }}>
                  {'Отмена'}
                </Button>
              </div>
              <div>
                <Button
                  className={styles.button_approve}
                  onClick={handleCancelAlert}
                  theme='filed'>
                  <div>{'Подтвердить'}</div>
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
